export enum CameraTipo {
    Default = 'Default',
    Unico = 'Unico',
    Vsoft = 'Vsoft',
    Oiti = 'Oiti',
    Fortface = 'Fortface',
    Serasa = 'Serasa',
    SerasaUnificadoLiveness = 'serasa-unificado-liveness',
}

export function cameraTipoToString(){
    return Object.values(CameraTipo)
            .map(cameraTipo => cameraTipo.toString())
            .reduce((acumulador, currentCameraTipo) => acumulador + `- ${currentCameraTipo} \n\t\t`, '');
}